import { render, staticRenderFns } from "./PromotionCreate.vue?vue&type=template&id=6db20a90&scoped=true&"
import script from "./PromotionCreate.vue?vue&type=script&lang=js&"
export * from "./PromotionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCreate.vue?vue&type=style&index=0&id=6db20a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db20a90",
  null
  
)

export default component.exports